import GetManualNotificationResponse, { NotificationCycle } from '../CRM/Responses/ManualNotificationResponse';

import Model from './Model';

export default class ManualNotification extends Model {
    readonly id: number;
    readonly admin_id: number | null;
    readonly title: string;
    readonly content: string;
    readonly is_active: boolean = false;
    readonly last_sent: string | null;
    readonly start_date: string;
    readonly cycle: NotificationCycle = NotificationCycle.Daily;
    readonly cycle_days: number[] | null = [];
    readonly left_to_deliver: number = 0;
    readonly end_date: string | null;
    readonly deliver_time: string = '00:00:00';
    readonly pinned_hours: number = 0;
    readonly created_at: string | null;
    readonly updated_at: string | null;

    constructor(response: Partial<GetManualNotificationResponse>) {
        super();
        this.assignDataToProps(response, [
            'id',
            'admin_id',
            'title',
            'content',
            'is_active',
            'last_sent',
            'start_date',
            'cycle',
            'cycle_days',
            'left_to_deliver',
            'end_date',
            'deliver_time',
            'pinned_hours',
            'created_at',
            'updated_at',
        ]);
    }
}
